import {
  ImportServiceSummaryFail,
  ImportServiceSummaryStarted,
  ImportServiceSummarySuccess
} from '../../../reducer/services/ImportServiceSummaryReducer';
import { postImportServiceSummary } from '../../actionType/services/ImportServiceSummaryActionType';
import { FetchImportFailure, FetchImportFailurePayload, FetchImportRequest, FetchImportStarted, FetchImportSuccess, FetchImportSuccessPayload } from '../../types/services/ImportAllServiceSummaryTypes';

export const fetchImportServiceSummaryRequest = (fileData: FormData): FetchImportRequest => ({
  type: postImportServiceSummary.POST_IMPORT_SERVICE_SUMMARY,
  fileData
});

/**
 * Fetch schema started saga action
 * @returns schema started action
 */
export const fetchImportStarted = (): FetchImportStarted => ({
  type: ImportServiceSummaryStarted.type
});

/**
 * Fetch schema success saga action
 * @param payload :schema data
 * @returns success action
 */
export const fetchImportSuccess = (
  payload: FetchImportSuccessPayload
): FetchImportSuccess => ({
  type: ImportServiceSummarySuccess.type,
  payload
});

/**
 * Fetch Schema Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchImportFailure = (
  payload: FetchImportFailurePayload
): FetchImportFailure => ({
  type: ImportServiceSummaryFail.type,
  payload
});
